// /accounts — list page.

import { createFileRoute } from "@tanstack/react-router";

import { AccountsListPage } from "../features/accounts/AccountsListPage";

export const Route = createFileRoute("/accounts/")({
  component: AccountsListPage,
});
